import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Grid,
  Modal,
  Select,
  TextInput,
  Title,
  Tooltip
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconBrandMedium,
  IconFilter,
  IconSearch,
  IconTimeDuration15,
  IconTrash,
} from "@tabler/icons-react";

import { DatePickerInput } from "@mantine/dates";
import { IconEye } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { _localization } from "../../../config/location";
import { api, apiPOS } from "../../../library/axios";
import { MessageResponse } from "../../../model/MessageResponse";

import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { IconEdit } from "@tabler/icons-react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import AppAction from "../../../common/AppAction";
import { BASE_API_URL } from "../../../config";
import EditImageContentKh from "./EditImageContentKh";
export interface CustomerImageModel {
  id: number;
  itemCode: string;
  branchCode: string;
  branchName: string;
  urls: string; // danh sách url, phân tách bằng dấu phẩy
  active: boolean;
  activeText: string | null;
  createdBy: string;
  createdAt: string;
  updatedBy: string | null;
  updatedAt: string | null;
  attribute1?: string | null;
  attribute2?: string | null;
  attribute3?: string | null;
  attribute4?: string | null;
  attribute5?: string | null;
}
const ImageContentKH = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 100,
  });
  const location = useLocation();
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);

  const [dataBrand, setDataBrand] = useState<any[]>([]);

  const [globalFilter, setGlobalFilter] = useState("");
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);

  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [modalImages, setModalImages] = useState<string[]>([]);
  const [openedImageModal, setOpenedImageModal] = useState(false);

  const formSeachInput = useForm<{
    KeySearch: string;
    Active: boolean | null;
    FromDate: Date | null;
    ToDate: Date | null;
    ItemCode: string;
    BranchSearch: string;
  }>({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      ItemCode: _searchJson && checkedPinSearch ? _searchJson?.ItemCode : "",
      Active: _searchJson && checkedPinSearch ? _searchJson?.Active : null,
      BranchSearch:
        _searchJson && checkedPinSearch ? _searchJson?.BranchSearch : "",
      FromDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.FromDate
            ? new Date(_searchJson.FromDate)
            : null
          : null,
      ToDate:
        _searchJson && checkedPinSearch
          ? _searchJson?.ToDate
            ? new Date(_searchJson.ToDate)
            : null
          : null,
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<CustomerImageModel>[]>(
    () => [
      {
        accessorKey: "STT",
        header: "STT",
        size: 80,
        Cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        accessorKey: "id",
        header: "ID",
        size: 60,
        Cell: ({ row }) => <span>{row.original.id}</span>,
      },
      {
        accessorKey: "itemCode",
        header: "SKU",
        size: 120,
        Cell: ({ row }) => <span>{row.original.itemCode}</span>,
      },
      {
        accessorKey: "createdAt",
        header: "Thời gian post",
        size: 140,
        Cell: ({ row }) => (
          <span>{formatDateTransfer(row.original.createdAt)}</span>
        ),
      },
      {
        header: "Xem thêm ",
        size: 140,
        Cell: ({ row }) => {
          const urls = row.original.urls?.split(",") || [];
          return (
            <Button
              variant="subtle"
              color="blue"
              size="xs"
              mt={4}
              leftSection={<IconEye size={18} />}
              onClick={() => {
                setModalImages(urls.map((u) => u.trim()));
                setOpenedImageModal(true);
              }}
            >
              Xem ảnh
            </Button>
          );
        },
      },
      {
        accessorKey: "urls",
        header: "Link ảnh",
        size: 650,
        Cell: ({ row }) => {
          const urls = row.original.urls?.split(",") || [];
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {urls.map((url: string, idx: number) => (
                <a
                  key={idx}
                  href={url.trim()}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1976d2" }}
                >
                  {url.trim()}
                </a>
              ))}
            </div>
          );
        },
      },
      {
        accessorKey: "branchName",
        header: "Tên Chi Nhánh",
        size: 350,
        Cell: ({ row }) => <span>{row.original.branchName}</span>,
      },
      {
        accessorKey: "active",
        header: "Trạng thái",
        size: 150,
        Cell: ({ row }) => {
          const isActive = row.original.active;
          return (
            <button
              style={{
                padding: "7px 22px",
                borderRadius: "999px",
                border: "none",
                fontWeight: 600,
                fontSize: "13px",
                color: isActive ? "#1976d2" : "#555",
                background: isActive ? "#e3f2fd" : "#f0f0f0",
                boxShadow: isActive ? "0 2px 8px #90caf9" : "0 2px 8px #ccc",
                cursor: "pointer",
                outline: "none",
                transition: "transform 0.15s,box-shadow 0.15s",
                letterSpacing: "0.5px",
                position: "relative",
              }}
              title={
                isActive
                  ? "Click để chuyển về Chưa đăng"
                  : "Click để chuyển về Đã dùng"
              }
              onClick={async (e) => {
                e.preventDefault();
                await handleUpdateStatus(row.original.id, isActive);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.04)";
                e.currentTarget.style.boxShadow = isActive
                  ? "0 6px 18px #90caf9"
                  : "0 6px 18px #bbb";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = isActive
                  ? "0 2px 8px #90caf9"
                  : "0 2px 8px #ccc";
              }}
            >
              {isActive ? "Đã dùng" : "Chưa đăng"}
            </button>
          );
        },
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 120,
        Cell: ({ row }) => (
          <Flex direction={"column"}>
            <EuiFlexGroup
              responsive={true}
              wrap={false}
              gutterSize="s"
              alignItems="center"
              justifyContent="center"
              style={{
                marginLeft: "20px",
              }}
            >
              <EuiFlexItem grow={false} style={{ textAlign: "center" }}>
                <Flex gap={"xs"}>
                  <Tooltip label="Chỉnh sửa">
                    <ActionIcon
                      variant="light"
                      aria-label="Settings"
                      color="green"
                      onClick={() => handleOpenModal(row.original)}
                    >
                      <IconEdit />
                    </ActionIcon>
                  </Tooltip>
                  <Tooltip label="Xóa danh mục">
                    <ActionIcon
                      variant="light"
                      aria-label="Settings"
                      color="red"
                      onClick={() => {
                        modals.openConfirmModal({
                          title: (
                            <Title order={5}>
                              {"Bạn có chắc chắn muốn xóa dữ liệu này "}
                            </Title>
                          ),
                          labels: { confirm: "Xóa", cancel: "Hủy" },
                          children: (
                            <>
                              <div
                                style={{
                                  width: "400px",
                                }}
                              ></div>
                            </>
                          ),
                          confirmProps: { color: "red" },
                          size: "md",
                          onConfirm: () => handleDelete([row.original.id]),
                        });
                      }}
                    >
                      <IconTrash />
                    </ActionIcon>
                  </Tooltip>
                </Flex>
              </EuiFlexItem>
            </EuiFlexGroup>
          </Flex>
        ),
      },
    ],
    []
  );


  // Hàm modal sửa
  const handleOpenModal = (data: CustomerImageModel) => {
    console.log("Logdataa", data);
    modals.openConfirmModal({
      title: (
        <>
          <div color="white">
            <Title order={5}>Chỉnh sửa hình ảnh khách hàng</Title>
          </div>
        </>
      ),
      children: <EditImageContentKh data={data} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      closeOnClickOutside: false,
      closeOnEscape: false,
      withCloseButton: false,
    });
  }
  // Xử lý xóa
  const handleDelete = async (id: number[]) => {
    setIsLoading(true);
    try {
      const response = await api.delete(`/CustomerImages/delete`, {
        data: { ids: id },
      });
      if (response && response.data.success) {
        await fetchData();
      } else {
        NotificationExtension.Fails(response?.data?.message || "Xóa thất bại!");
      }
    } catch (error: any) {
      NotificationExtension.Fails(
        error?.response?.data?.message || "Xóa thất bại!"
      );
      console.error("Error deleting:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleUpdateStatus = async (id: number, isActive: boolean) => {
    try {
      const response = await api.put("/CustomerImages/active", {
        ids: [id],
        isActive: !isActive,
      });
      if (response && response.data.success) {
        await fetchData();
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const [originalData, setOriginalData] = useState<CustomerImageModel[]>([]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let queryParams = `?Skip=${pagination?.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;
      const values = formSeachInput.getValues();
      if (values.KeySearch) {
        queryParams += `&KeySearch=${values.KeySearch}`;
      }
      if (values.ItemCode) {
        queryParams += `&ItemCode=${values.ItemCode}`;
      }
      if (values.BranchSearch) {
        // Lấy tối đa 5 từ đầu tiên
        // const branchWords = values.BranchSearch.split(" ")
        //   .slice(0, 5)
        //   .join(" ");
        queryParams += `&BranchSearch=${values.BranchSearch.trim()}`;
      }
      if (values.Active != null) {
        const activeValue = values.Active;
        queryParams += `&Active=${activeValue ? "true" : "false"}`;
      }
      const formatDateLocalToUTC0 = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}T00:00:00.000Z`;
      };
      if (values.FromDate) {
        queryParams += `&FromDate=${formatDateLocalToUTC0(values.FromDate)}`;
      }
      if (values.ToDate) {
        queryParams += `&ToDate=${formatDateLocalToUTC0(values.ToDate)}`;
      }
      const response = await api.get("/CustomerImages/get-list" + queryParams);
      if (response && response.data.success) {
        setOriginalData(response.data.data ?? []);
        setRowCount(response.data.totalCount ?? 0);
      }
    } catch (error: any) {
      setOriginalData([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Lấy dữ liệu chi nhánh
    const getBrand = async () => {
      try {
        const url = `/api-pos/api/v1/TblDmInventory/get-select-branch?auth=false`;
        const res = await apiPOS.get<MessageResponse<SelectListItemBase[]>>(
          url
        );
        console.log("resssss", res);
        if (res && res?.data.success && res.data) {
          const result = res.data.data.filter((item) => item.att2 != null);
          setDataBrand(result);
        }
      } catch (err) {
        console.error("Failed to fetch branch data:", err);
      }
    };
    getBrand();
  }, []);
  console.log("dataBrand", dataBrand);
  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
  }, [rowSelectionDeferred]);

  const table = useMantineReactTable<CustomerImageModel>({
    columns,
    data: originalData || [],
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    // getRowId: (row) => row.id,
    // mantineTableContainerProps: {
    //   style: { maxHeight: height, minHeight: height },
    // },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
  });

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 220 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (220 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  // console.log("formSeachInput.getValues()", formSeachInput.getValues());
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  const handleExportExcel = async () => {
    setIsLoading(true);
    try {
      let url = "/ExportExcel/export-customer-image";
      const values = formSeachInput.getValues();

      const formatDateLocalToUTC0 = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}T00:00:00.000Z`;
      };

      if (values.KeySearch) {
        url += `${url.includes("?") ? "&" : "?"}KeySearch=${values.KeySearch}`;
      }
      if (values.ItemCode) {
        url += `${url.includes("?") ? "&" : "?"}ItemCode=${values.ItemCode}`;
      }
      if (values.FromDate) {
        url += `${url.includes("?") ? "&" : "?"
          }FromDate=${formatDateLocalToUTC0(values.FromDate)}`;
      }
      if (values.ToDate) {
        url += `${url.includes("?") ? "&" : "?"}ToDate=${formatDateLocalToUTC0(
          values.ToDate
        )}`;
      }
      if (values.BranchSearch) {
        // Lấy tối đa 5 từ đầu tiên
        const branchWords = values.BranchSearch.split(" ")
          .slice(0, 5)
          .join(" ");
        url += `${url.includes("?") ? "&" : "?"}BranchSearch=${branchWords}`;
      }
      if (values.Active != null) {
        const activeValue = values.Active;
        url += `${url.includes("?") ? "&" : "?"}Active=${activeValue ? "true" : "false"
          }`;
      }
      const _url = BASE_API_URL + url;

      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "danh_sach_anh_khach_hang" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(urlss);
      }
    } catch (error) {
      console.log(error);
      NotificationExtension.Fails("Lỗi khi export Excel!");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={isLoading} />
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
        <Flex gap={"md"} align={"center"}>
          <Button
            color="red"
            variant="outline"
            size="sm"
            disabled={selectIds.length === 0}
            onClick={() => {
              modals.openConfirmModal({
                title: (
                  <Title order={5}>
                    {"Bạn có chắc chắn muốn xóa dữ liệu này "}
                  </Title>
                ),
                children: (
                  <div
                    style={{
                      width: "400px",
                    }}
                  >
                    <span>
                      Bạn có chắc chắn muốn xóa tất cả các dữ liệu đã chọn?
                    </span>
                  </div>
                ),
                labels: { confirm: "Xóa tất cả", cancel: "Hủy" },
                confirmProps: { color: "red" },
                onConfirm: () => handleDelete(selectIds.map(Number)),
              });
            }}
          >
            Xóa tất cả đã chọn
          </Button>
          <AppAction openExportExcel={handleExportExcel} />
        </Flex>
      </Flex>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
        ref={headerRef}
      >
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <Grid w={"90%"}>
            <Grid.Col span={sizeGrid}>
              <TextInput
                size="md"
                width="100%"
                placeholder="Từ khoá sku"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("ItemCode")}
                {...formSeachInput.getInputProps("ItemCode")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
              />
            </Grid.Col>
            {/* <Grid.Col span={sizeGrid}>
              <TextInput
                size="md"
                width="100%"
                placeholder="Chi nhánh"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={formSeachInput.key("BranchSearch")}
                {...formSeachInput.getInputProps("BranchSearch")}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchData();
                  }
                }}
              />
            </Grid.Col> */}
            <Grid.Col span={sizeGrid}>
              <Select
                size="md"
                searchable
                clearable
                placeholder="Chi nhánh"
                leftSection={<IconBrandMedium color="#15aabf" />}
                data={
                  Array.isArray(dataBrand)
                    ? dataBrand
                      .filter((branch) => branch.attr6 === "HACOM")
                      .map((item) => ({
                        value: item.att2,
                        label: item.addressNew ? item.addressNew : item.att1,
                      }))
                    : []
                }
                key={formSeachInput.key("BranchSearch")}
                {...formSeachInput.getInputProps("BranchSearch")}
                onChange={async (value) => {
                  formSeachInput.setFieldValue(
                    "BranchSearch",
                    value ? value : ""
                  );
                }}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                searchable
                clearable
                placeholder="Lọc theo Trạng thái"
                size="md"
                leftSection={<IconFilter color="#15aabf" />}
                data={[
                  {
                    value: "Y",
                    label: "Đã dùng",
                  },
                  {
                    value: "N",
                    label: "Chưa đăng",
                  },
                ]}
                value={
                  formSeachInput.getValues().Active === true
                    ? "Y"
                    : formSeachInput.getValues().Active === false
                      ? "N"
                      : null
                }
                key={formSeachInput.key("Active")}
                onChange={async (value) => {
                  formSeachInput.setFieldValue(
                    "Active",
                    value === "Y" ? true : value === "N" ? false : null
                  );
                }}
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Từ ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                key={formSeachInput.key("FromDate")}
                {...formSeachInput.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <DatePickerInput
                size="sm"
                placeholder="Đến ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                key={formSeachInput.key("ToDate")}
                {...formSeachInput.getInputProps("ToDate")}
                clearable
              />
            </Grid.Col>

            <Grid.Col span={sizeGrid}>
              <Button
                type="submit"
                leftSection={<IconSearch size={20} />}
                color="blue"
                size="md"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </Flex>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
      <Modal
        opened={openedImageModal}
        onClose={() => setOpenedImageModal(false)}
        title="Danh sách hình ảnh"
        size="lg"
        centered
      >
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          navigation
          modules={[Navigation]}
          style={{
            maxWidth: "100%",
            minWidth: "600px",
            margin: "0 auto",
            padding: "20px",
          }}
        >
          {modalImages.map((url, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={url}
                alt={`img-${idx}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: 400,
                  margin: "0 auto",
                  minWidth: 300,
                  borderRadius: 8,
                  boxShadow: "0 2px 8px #ccc",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Modal>
    </Box>
  );
};

export default ImageContentKH;
